<template>
    <div class="Register">
        <div class="container">
            <h2>{{'Create an Account' | language}}</h2>
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <el-alert title="Email" type="error" v-for="(content, index) of errorContent.email" :key="index"
                        :description="content" show-icon>
                    </el-alert>
                    <el-form :model="register" status-icon :rules="$store.state.general.language ==='english' ? rules : rulesJp" ref="register" label-width="120px" class="demo-ruleForm"
                        @submit.native.prevent
                        :label-position="labelPosition">
                        <el-form-item :label="'Name' | language" prop="name">
                            <el-input v-model="register.name" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                        </el-form-item>
                            <el-form-item :label="'Company' | language" prop="company">
                            <el-input  v-model="register.company" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                        </el-form-item>
                            <el-form-item :label="'Phone' | language" prop="phone">
                            <el-input  v-model="register.phone" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                        </el-form-item>
                            <el-form-item :label="'Email' | language" prop="email">
                            <el-input v-model="register.email" @keyup.enter.native="submitForm('register')" ></el-input>
                        </el-form-item>
                        <el-form-item :label="'Password' | language" prop="pass">
                            <el-input type="password" v-model="register.pass" autocomplete="off" @keyup.enter.native="submitForm('register')"  ></el-input>
                        </el-form-item>
                        <el-form-item :label="'Confirm Password' | language" prop="checkPass">
                            <el-input type="password" v-model="register.checkPass" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                        </el-form-item>
                        <el-form-item prop="policy">
                            <el-checkbox  name="policy" v-model="register.policy" ><small>{{'By registering you accept our Terms of Services and Privacy Policy' | language}}</small></el-checkbox>
                        </el-form-item>

                        <el-form-item>
                            <el-button class="Register__Button" type="primary" @click="submitForm('register')" :loading="loading" >{{'Create an Account' | language}}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="col-sm-6 col-xs-12 features">
                    <div class="feature">
                        <i class="el-icon-star-off icon"></i>
                        <div class="feature-text">
                            <h5>{{"Don't miss a thing" | language}}</h5>
                            <p>{{'Save homes you loved and access them quickly' | language}}</p>
                        </div>
                    </div>
                    <div class="feature">
                        <i class="el-icon-school icon"></i>
                        <div class="feature-text">
                            <h5>{{'Be up to date' | language}}</h5>
                            <p>{{'Receive special deals and updates on your favourite properties' | language}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Please input the password'));
                } else {
                    if (this.register.checkPass !== '') {
                        this.$refs.register.validateField('checkPass');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Please input the password again'));
                } else if (value !== this.register.pass) {
                    callback(new Error('Two inputs don\'t match!'));
                } else {
                    callback();
                }
            };
            return {
                labelPosition: 'top',
                register: {
                    name: '',
                    company: '',
                    email: '',
                    phone: '',
                    pass: '',
                    checkPass: '',
                    policy: ''
                },
                errorContent: '',
                loading: false,
                rules: {
                    pass: [
                        { validator: validatePass, trigger: 'change' ,required:true},
                        { min:8,message:'Length should be at least 8'}
                    ],
                    checkPass: [
                        { validator: validatePass2, trigger: 'change',required:true },
                        { min:8,message:'Length should be at least 8'}
                    ],
                    policy:[
                        { required: true, message: 'Please Accept our Terms of Services and Privacy Policy' }
                    ],
                    name:[
                        {required: true, message: 'Please input your name', trigger:'blur'}
                    ],
                    email:[
                        { required: true, message: 'Please input email address', trigger: 'blur' },
                        { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
                    ]
                },
                rulesJp: {
                    pass: [
                        { validator: validatePass, trigger: 'change' ,required:true},
                        { min:8,message:'長さは8文字以上にする必要があります'}
                    ],
                    checkPass: [
                        { validator: validatePass2, trigger: 'change',required:true },
                        { min:8,message:'長さは8文字以上にする必要があります'}
                    ],
                    policy:[
                        { required: true, message: '利用規約とプライバシーポリシーに同意してください' }
                    ],
                    name:[
                        {required: true, message: 'あなたの名を入力してくださ', trigger:'blur'}
                    ],
                    email:[
                        { required: true, message: 'メールアドレスを入力してください', trigger: 'blur' },
                        { type: 'email', message: '正しいメールアドレスを入力してください', trigger: ['blur', 'change'] }
                    ]
                },
            };
        },
        methods: {
            submitForm(formName) {
                event.preventDefault()
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.errorContent = ''
                        const promise = this.$store.dispatch('user/register', this.register)
                        promise
                        .then(() => {
                            this.$router.push({
                            path: '/login',
                            query: {}
                            })
                        })
                        .catch(err => {
                            this.errorContent = err
                        })
                        .finally(() => {
                            this.loading = false
                        })
                    } else {
                        return false
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        },
        head: {
            title: function() {
                return {
                    inner: 'Register'
                }
            },
            meta: [
                { name: 'title', content: 'Create an account with Japan Home Finder' },
                { name: 'keywords', content: 'japan home finder, japan realestate, apartment, house, for rent, for lease' },
                { name: 'description', content: 'Making your Japan home search easier' }
            ]
        }
    }
</script>

<style lang="scss" scoped>
    .Register {
        padding: 1em 0;

        form {
            max-width: 400px;
            margin-left: auto;

            .el-form-item {
                &.is-error {
                    margin-bottom: 1em!important;
                }
            }

            .bottom-links {
                margin-top: .5em!important;
            }

            .navigation__navitem {
                padding: 0;
                color: $alternate-color;

                &.forgot-password {
                    float: right;
                }
            }

            .el-checkbox {
                white-space: normal;
                display: flex;
                align-items: center;
                margin-top: 1em;
            }
        }

        h2 {
            text-align: center;
        }

        &__Button {
            width: 100%;
            margin-top: 2em;
        }

        .feature {
            display: flex;
            align-items: center;
            margin-top: 1.5em;
            padding-left: 2em;
            max-width: 420px;

            .icon {
                font-size: 2em;
                margin-right: .5em;
                color: rgba($alternate-color, .3);

                &.el-icon-house {
                    font-size: 1.5em;
                }
            }

            h5 {
                margin: 0;
            }

            p {
                margin: 0;
            }
        }

        @media (max-width: 767px) {
            form {
                margin: 0 auto;
            }

            .features {
                padding-top: 1em;
                border-top: 1px solid;
                max-width: 420px;
                margin: 2em auto 0 auto;
            }

            .feature {
                margin: 1em auto;
                padding: 0;
            }
        }
    }
</style>